import apiService from '../apiService'

export const regulatoryController = configService => {
  const service = apiService(configService)

  return {
    downloadRegulatory: params => {
      return service.downloadFile({
        url: `cms/buyer/regulatory/form/download`,
        params,
      })
    },

    uploadRegulatory: formData => {
      return service.uploadFile({
        url: `cms/buyer/regulatory/form/upload?file`,
        formData,
      })
    },
  }
}
